module.exports = __webpack_public_path__ + "static/desktop/img/photobook-1.a727b01e.png";